import { render, staticRenderFns } from "./lcdAdvertisingSettings.vue?vue&type=template&id=5bdbb1d2&scoped=true&"
import script from "./lcdAdvertisingSettings.vue?vue&type=script&lang=js&"
export * from "./lcdAdvertisingSettings.vue?vue&type=script&lang=js&"
import style0 from "./lcdAdvertisingSettings.vue?vue&type=style&index=0&id=5bdbb1d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdbb1d2",
  null
  
)

export default component.exports